import { Link } from "react-router-dom";
import { LogoMark } from "@/components/site/Logo";
import { NewsletterForm } from "@/components/site/NewsletterForm";
import { journals, site } from "@/content/site";

const Col = ({ title, children }) => (
  <div>
    <h3 className="eyebrow !text-[var(--gold)] mb-5">{title}</h3>
    <ul className="space-y-3 text-[#D5DCD7]">{children}</ul>
  </div>
);

export const Footer = () => (
  <footer className="bg-[var(--emerald)] text-[var(--paper)] relative overflow-hidden" data-testid="site-footer">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 pt-20 lg:pt-28 pb-10">
      <div className="grid lg:grid-cols-12 gap-14">
        <div className="lg:col-span-5">
          <p className="eyebrow !text-[var(--gold)] mb-5">The Motive Dispatch</p>
          <h2 className="font-display text-4xl sm:text-5xl leading-[1.05] mb-8">New issues and calls for papers, <em>delivered quietly.</em></h2>
          <NewsletterForm />
        </div>
        <div className="lg:col-span-6 lg:col-start-7 grid grid-cols-2 sm:grid-cols-3 gap-10">
          <Col title="Journals">
            {journals.map((j) => (
              <li key={j.slug}><Link to={`/index.php/${j.slug}`} className="link-u" data-testid={`footer-journal-${j.slug}`}>{j.title}</Link></li>
            ))}
          </Col>
          <Col title="Information">
            {["readers", "authors", "librarians"].map((t) => (
              <li key={t}><Link to={`/index.php/ESGS/information/${t}`} className="link-u capitalize" data-testid={`footer-info-${t}`}>For {t}</Link></li>
            ))}
            <li><Link to="/index.php/ESGS/about/privacy" className="link-u" data-testid="footer-privacy">Privacy Statement</Link></li>
          </Col>
          <Col title="Account">
            <li><Link to="/login" className="link-u" data-testid="footer-login">Login</Link></li>
            <li><Link to="/register" className="link-u" data-testid="footer-register">Register</Link></li>
            <li><Link to="/search" className="link-u" data-testid="footer-search">Search</Link></li>
            <li><Link to="/index.php/ESGS/about/contact" className="link-u" data-testid="footer-contact">Contact</Link></li>
          </Col>
        </div>
      </div>
      <div className="mt-20 lg:mt-28 flex items-end gap-4 select-none" aria-hidden="true">
        <LogoMark light className="w-14 h-14 sm:w-20 sm:h-20 shrink-0" />
        <span className="font-display leading-[0.8] text-[18vw] lg:text-[13rem] tracking-[-0.03em] text-[var(--paper)]">Motive <em>Press</em></span>
      </div>
      <div className="mt-10 pt-6 border-t border-white/15 flex flex-col sm:flex-row gap-4 justify-between text-sm text-[#C9D2CC]">
        <span>© {new Date().getFullYear()} {site.name}. All rights reserved.</span>
        <Link to="/about/aboutThisPublishingSystem" className="link-u" data-testid="footer-ojs-link">{site.platform.label}</Link>
      </div>
    </div>
  </footer>
);
